import Axios from "axios";
import {
  GET_BRAND_CRM,
  SAVE_BRAND_CRM,
  TEST_BRAND_CRM,
  DELETE_BRAND_CRM,
} from "../actionTypes";

const getToken = () => localStorage.getItem(process.env.REACT_APP_USERTOKEN);

const authHeader = () => ({
  Accept: "application/json",
  Authorization: `Bearer ${getToken()}`,
});

export const getBrandCrmAction = () => async (dispatch) => {
  dispatch({ type: GET_BRAND_CRM.REQUEST });
  try {
    const { data } = await Axios.get(
      `${process.env.REACT_APP_BASEURL}brand/crm-integration`,
      { headers: authHeader() },
    );
    dispatch({ type: GET_BRAND_CRM.SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_BRAND_CRM.ERROR, payload: error.message });
  }
};
export const saveBrandCrmAction = (formData) => async (dispatch) => {
  dispatch({ type: SAVE_BRAND_CRM.REQUEST });
  try {
    const { data } = await Axios.post(
      `${process.env.REACT_APP_BASEURL}brand/crm-integration`,
      formData,
      { headers: authHeader() },
    );
    dispatch({ type: SAVE_BRAND_CRM.SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: SAVE_BRAND_CRM.ERROR,
      payload:
        error?.response?.data?.msg ??
        error?.response?.data?.message ??
        error.message,
    });
  }
};

export const saveBrandCrmResetAction = () => (dispatch) => {
  dispatch({ type: SAVE_BRAND_CRM.RESET });
};

export const testBrandCrmAction = (formData) => async (dispatch) => {
  dispatch({ type: TEST_BRAND_CRM.REQUEST });
  try {
    const { data } = await Axios.post(
      `${process.env.REACT_APP_BASEURL}brand/crm-integration/test`,
      formData,
      { headers: authHeader() },
    );
    dispatch({ type: TEST_BRAND_CRM.SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: TEST_BRAND_CRM.ERROR,
      payload:
        error?.response?.data?.msg ??
        error?.response?.data?.message ??
        error.message,
    });
  }
};

export const testBrandCrmResetAction = () => (dispatch) => {
  dispatch({ type: TEST_BRAND_CRM.RESET });
};

export const deleteBrandCrmAction = () => async (dispatch) => {
  dispatch({ type: DELETE_BRAND_CRM.REQUEST });
  try {
    const { data } = await Axios.delete(
      `${process.env.REACT_APP_BASEURL}brand/crm-integration`,
      { headers: authHeader() },
    );
    dispatch({ type: DELETE_BRAND_CRM.SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: DELETE_BRAND_CRM.ERROR,
      payload: error?.response?.data?.message ?? error.message,
    });
  }
};

export const deleteBrandCrmResetAction = () => (dispatch) => {
  dispatch({ type: DELETE_BRAND_CRM.RESET });
};
